// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1DkGG","inputDescription":"styles_inputDescription__-O2ow"};